import { create } from 'zustand'
import { DomainContextProps } from './storeTypes/domain.storeTypes'
import { ExamStoreTypes } from './storeTypes/exam.storeTypes'
import { QuestionBankTypes } from '../interfaces/question.interface';


export type QuestionContextProps = {
  QBankListing: Array<QuestionBankTypes>;
  setQBankListing: (data:Array<QuestionBankTypes>)=>void;
};


const useQuestionStores = create<QuestionContextProps>((set) => ({
    QBankListing:[],
    setQBankListing:(data:Array<QuestionBankTypes>)=>set(()=>({QBankListing:data}))
    
}))

export default useQuestionStores